import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import {
    IFrameProperty,
    IFrame,
} from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IPoint } from '../../../../../infrastructure/module/independent/graphic/point/point.interface';
import { getFrameAfterRotate } from '@src/slide/infrastructure/module/independent/graphic';
import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';
import BaseFrame from './base';
import { GroupChildrenFrameHanler } from './group/group-children-frame';
import { IFrameProps, IValueProps } from './base/base.interface';

export default class Frame extends BaseFrame implements IFrameProperty {
    private groupFrameHanlder: GroupChildrenFrameHanler;
    public constructor(model: IElementBaseModel) {
        super(model);
        this.groupFrameHanlder = new GroupChildrenFrameHanler(model);
    }

    public frameOnSlide(frameOfGroup?: IFrame | undefined, isOperation?: boolean | undefined): IFrame {
        return this.getFinalFrameInfo(isOperation, true, frameOfGroup);
    }

    public updateHeight(props: IValueProps): void {
        this.batchUpdateFrameHandler.batchUpdateHeight({
            ...props, value: [props.value],
            updateModelArr: [this.model],
        });
    }

    public updateWidth(props: IValueProps): void {
        this.batchUpdateFrameHandler.batchUpdateWidth({
            ...props, value: [props.value],
            updateModelArr: [this.model],
        });
    }

    public updateLeft(left: number, isOnSlide?: boolean): void {
        this.batchUpdateFrameHandler.batchUpdateLeft([left], [this.model], isOnSlide);
    }

    public updateTop(top: number, isOnSlide?: boolean): void {
        this.batchUpdateFrameHandler.batchUpdateTop([top], [this.model], isOnSlide);
    }

    public updateRotate(rotate: number, isOnSlide?: boolean): void {
        if (this.model.type === UIModelType.TABLE) return;
        this.batchUpdateFrameHandler.batchUpdateRotateToAngle(rotate, [this.model], isOnSlide);
    }

    public rotateByCurrent(rotate: number, isOnSlide?: boolean): void {
        if (this.model.type === UIModelType.TABLE) return;
        this.batchUpdateFrameHandler.batchUpdateRotateWithAngle(rotate, [this.model], isOnSlide);
    }

    public updateFrame(props: IFrameProps): void {
        this.batchUpdateFrameHandler.batchUpdateFrame({ ...props, frame: [props.frame], updateModelArr: [this.model] });
    }

    public updateFrameOnSlide(props: IFrameProps) {
        this.batchUpdateFrameHandler.batchUpdateFrameOnSlide({
            ...props, frame: [props.frame],
            updateModelArr: [this.model],
        });
    }

    public convertFrameOnSlideToSelf(frameOfSlide: IFrame): IFrame {
        return this.groupFrameHanlder.convertFrameOnSlideToSelf(frameOfSlide);
    }

    public boundingRectOnSlide(currentFrame?: IFrame | undefined, isOperation?: boolean | undefined): IRect {
        const frame = this.frameOnSlide(currentFrame, isOperation);
        const rotate = frame.rotate ? frame.rotate : 0;
        const rect = getFrameAfterRotate(frame, rotate);
        return rect;
    }

    public pointOnSlide(originalPoint: IPoint, isOperating: boolean): IPoint {
        return this.groupFrameHanlder.pointOnSlide(originalPoint, isOperating);
    }

    public pointToElement(originalPoint: IPoint, isOperating: boolean): IPoint {
        return this.groupFrameHanlder.pointToElement(originalPoint, isOperating);
    }

    public outerFrameOnSlide(): IFrame {
        const frame = this.frameOnSlide(undefined, !!(this.model as IElementBaseModel).operationFrame);
        const outer = frame.rotate ? getFrameAfterRotate(frame, frame.rotate) : frame;
        return outer;
    }

    protected getFinalFrameInfo(isOperating?: boolean, isOnSlide?: boolean, currentFrame?: IFrame): IFrame {
        const frame = isOnSlide ? this.groupFrameHanlder.frameOnSlide(currentFrame, isOperating)
            : this.getFinalFrame(this.model as IElementBaseModel, isOperating);
        return frame;
    }
}
